module.exports = __webpack_public_path__ + "static/img/login1.8efd570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/login1.png
// module id = 345
// module chunks = 0